import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreatePaymentPurposeFailure,
  CreatePaymentPurposeRequest,
  CreatePaymentPurposeSuccess,
  DeletePaymentPurposeFailure,
  DeletePaymentPurposeRequest,
  DeletePaymentPurposeSuccess,
  FetchPaymentPurposeFailure,
  FetchPaymentPurposeRequest,
  FetchPaymentPurposeSuccess,
  FetchPaymentPurposesFailure,
  FetchPaymentPurposesRequest,
  FetchPaymentPurposesSuccess,
  UpdatePaymentPurposeFailure,
  UpdatePaymentPurposeRequest,
  UpdatePaymentPurposeSuccess,
} from './payment-purposes.actions'
import { PaymentPurposesService } from './payment-purposes.service'
import * as PaymentPurposes from './payment-purposes.types'

@Injectable()
export class PaymentPurposesEffects {
  constructor(
    private actions: Actions,
    private PaymentPurposesService: PaymentPurposesService,
    private router: Router,
  ) {}

  FetchPaymentPurposes$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaymentPurposes.FETCH_PAYMENT_PURPOSES_REQUEST),
      switchMap((action: FetchPaymentPurposesRequest) => {
        return this.PaymentPurposesService.fetchPaymentPurposes(
          action.payload,
        ).pipe(
          map((result) => {
            return new FetchPaymentPurposesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchPaymentPurposesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchPaymentPurpose$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaymentPurposes.FETCH_PAYMENT_PURPOSE_REQUEST),
      switchMap((action: FetchPaymentPurposeRequest) => {
        return this.PaymentPurposesService.fetchPaymentPurpose(action.id).pipe(
          map((result) => {
            return new FetchPaymentPurposeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPaymentPurposeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeletePaymentPurpose$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaymentPurposes.DELETE_PAYMENT_PURPOSE_REQUEST),
      switchMap((action: DeletePaymentPurposeRequest) => {
        return this.PaymentPurposesService.deletePaymentPurpose(action.id).pipe(
          switchMap(() => {
            return [new DeletePaymentPurposeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeletePaymentPurposeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreatePaymentPurpose$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaymentPurposes.CREATE_PAYMENT_PURPOSE_REQUEST),
      switchMap((action: CreatePaymentPurposeRequest) => {
        return this.PaymentPurposesService.createPaymentPurpose(
          action.payload,
        ).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/payment-purposes'])
            return [new CreatePaymentPurposeSuccess()]
          }),
          catchError(() => {
            return of(new CreatePaymentPurposeFailure({}))
          }),
        )
      }),
    ),
  )

  UpdatePaymentPurpose$ = createEffect(() =>
    this.actions.pipe(
      ofType(PaymentPurposes.UPDATE_PAYMENT_PURPOSE_REQUEST),
      switchMap((action: UpdatePaymentPurposeRequest) => {
        return this.PaymentPurposesService.updatePaymentPurpose(
          action.id,
          action.payload,
        ).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/payment-purposes'])
            return [new UpdatePaymentPurposeSuccess()]
          }),
          catchError(() => {
            return of(new UpdatePaymentPurposeFailure({}))
          }),
        )
      }),
    ),
  )
}
